<template>
    <Paper
        class="favorite-card-root p-4 pointer d-flex flex-column align-items-center"
        @click.native="goToJob"
    >
        <div class="image-wrapper">
            <img class="image" :src="logo" />
        </div>
        <h6 class="text-center subtitle mt-2 mb-1">{{ title() }}</h6>
        <div class="flex-grow" />
        <!--  <p class='text-center caption mute mb-2'>{{ address() }}</p> -->
        <p class="text-center caption mute">
            {{ $t('shared.postingModule.postCard.deadline') }} {{ deadline() }}
        </p>
    </Paper>
</template>

<script>
import dateToString from '~/utils/dateToString';

export default {
    name: 'FavoriteCard',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        logo() {
            return this.job().companyLogo || null;
        },
    },
    methods: {
        goToJob() {
            let jobId = null;
            if (this.data.job) {
                jobId = this.data.job.id;
            } else {
                jobId = ''.concat(this.data.jobAdId, '?isJobAdId=true');
            }
            this.$router.push(this.$URLS.jobDetail.concat('/', jobId));
        },
        job() {
            return this.data.job || {};
        },
        title() {
            return this.job().title || null;
        },
        address() {
            return this.job().address || null;
        },
        deadline() {
            return this.data.job ? dateToString(this.job().deadline) : null;
        },
    },
};
</script>

<style scoped>
.favorite-card-root:hover {
    box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.15) !important;
    transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
}

.image-wrapper {
    max-width: 200px;
    max-height: 100px;
    height: 100px;
    overflow: hidden;
}

.image {
    width: 100%;
    height: 100%;
    max-height: 100px;
    object-fit: scale-down;
}
</style>
